import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import CtCmbEditable from "../Components/CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCLost extends Component {
  state = {
    formData: {
      dtpLostDate: get_YMD_from_SYS(new Date()),
      cmbLostReason: "",
      txtLostOtherReason: "",
      txtRemark: "",
    },
    lostReasonList: [
      { name: "Price Issue" },
      { name: "Service Issue" },
      { name: "Other Reason" },
    ],
  };

  componentDidMount() {
    document.title = "AMC Lost";
    localStorage.setItem("Heading", "AMC Lost");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpLostDate")?.focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  lostAMC = () => {
    const { dtpLostDate, cmbLostReason, txtLostOtherReason } =
      this.state.formData;
    if (!dtpLostDate) {
      this.props.toastErrorMsg("Select Lost Date", "dtpLostDate");
      return;
    }
    if (!cmbLostReason) {
      this.props.toastErrorMsg("Select Lost Reason", "cmbLostReason");
      return;
    }
    if (cmbLostReason === "Other Reason" && !txtLostOtherReason) {
      this.props.toastErrorMsg("Enter Other Reason", "txtLostOtherReason");
      return;
    }
    this.props.toastMsg("success", "AMC Lost Successfully");
    this.clearInfo();
  };

  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        dtpLostDate: "",
        txtLostOtherReason: "",
        cmbLostReason: "",
        txtRemark: "",
      },
    });
  };

  render() {
    const { formData } = this.state;
    return (
      <form>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Typography sx={{ color: "text.primary" }}>Lost AMC</Typography>
        </Breadcrumbs> */}

        <Grid container spacing={2} marginTop={2}>
          <Grid item>
            <CtDtp
              id="dtpLostDate"
              label="Date*"
              value={formData.dtpLostDate}
              handleOnChange={this.handleOnChange}
              width={180}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"cmbLostReason"}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbLostReason"
              label="Reason*"
              items={this.state.lostReasonList}
              colID="name"
              value={formData.cmbLostReason}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={
                formData.cmbLostReason === "Other Reason"
                  ? "txtLostOtherReason"
                  : "txtRemark"
              }
            />
          </Grid>
          {formData.cmbLostReason === "Other Reason" ? (
            <Grid item xs={12}>
              <CtMultiLineText
                id="txtLostOtherReason"
                label="Other Reason*"
                value={formData.txtLostOtherReason}
                handleOnChange={this.handleOnChange}
                width={520}
                maxLength={1000}
              />
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Lost"
              className="delete-button"
              onClick={this.lostAMC}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCLost {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
